import React, {Component} from "react";

import WithUserData from "../WithUserData";
import ClubMessages from "../../../assets/images/club_messages.svg";
import DirectMessaging from "../../../assets/images/direct_messaging.svg";
import JobOffers from "../../../assets/images/ads_offers.svg";
import NewsEventsOffers from "../../../assets/images/news_events_offers.svg";

export default class Notifications extends Component {

    render() {
        const buttonClassName = "cursor-pointer w-full h-16 border border-black text-gray-900 text-lg rounded-lg flex items-center hover:bg-gray-200 mt-0 sm:mt-3"
        const iconClassName = "h-10";
        return (
            <WithUserData>
                {() => {
                    return (
                        <div className='w-full h-full flex flex-col justify-end sm:justify-start'>
                            <div className={`${buttonClassName} mt-6 sm:mt-20`}>
                                <div className="w-24 flex items-center justify-center">
                                    <img src={ClubMessages} className={iconClassName} alt="ClubMessages" />
                                </div>
                                <span>Club messages</span>
                            </div>
                            <div className={buttonClassName}>
                                <div className="w-24 flex items-center justify-center">
                                    <img src={DirectMessaging} className={iconClassName} alt="DirectMessaging" />
                                </div>
                                <span>Direct messaging</span>
                            </div>
                            <div className={buttonClassName}>
                                <div className="w-24 flex items-center justify-center">
                                    <img src={JobOffers} className={iconClassName} alt="JobOffers" />
                                </div>
                                <span>Job offers</span>
                            </div>
                            <div className={buttonClassName}>
                                <div className="w-24 flex items-center justify-center">
                                    <img src={NewsEventsOffers} className={iconClassName} alt="NewsEventsOffers" />
                                </div>
                                <span>News, events & offers</span>
                            </div>
                        </div>
                    )
                }}
            </WithUserData>
        );
    }
}
